// extracted by mini-css-extract-plugin
export default {"wrapper":"S0-z","play":"T0-z"};